import { RouterView, type RouterOptions } from "vue-router";
import EntityAudits from "@/components/EntityAudits.vue";
import { EntityNotes } from "@modernary/mui/components/note";
import { getLookupsFromLookupGroup } from "@modernary/mui/components/lookup";
// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  recyclingReports: "RecyclingReport.RecyclingReports",
  list: "RecyclingReport.RecyclingReportList",
  new: "RecyclingReport.RecyclingReportNew",
  base: "RecyclingReport.RecyclingReportBase",
  view: "RecyclingReport.RecyclingReportView",
  edit: "RecyclingReport.RecyclingReportEdit",
  notes: "RecyclingReport.RecyclingReportNotes",
  noteEdit: "RecyclingReport.RecyclingReportNoteEdit",
  noteNew: "RecyclingReport.RecyclingReportNoteNew",
  audit: "RecyclingReport.RecyclingReportAudit",
};

// {
//   path: "list",
//   name: names.stationarySourcePermittingList,
//   meta: { title: "Stationary Source Forms" },
//   props: (route) => ({
//     filterMurns: route.params.filterMurns,
//   }),
//   beforeEnter: async (to, from, next) => {
//     try {
//       const formTypeLookups = await getLookupsFromLookupGroup("ElectronicFormType");

//       to.params.filterMurns = formTypeLookups._items
//         .filter((lookup) =>
//           lookup.metadata?.filtersOn?.groupMurn.values.includes(
//             LE.ElectronicFormGroup.StationarySourcePermitting,
//           ),
//         )
//         .map((x) => x.murn);

//       next();
//     } catch (error) {
//       next({ name: "errorRoute" }); //TODO:
//     }
//   },
//   component: () => import("@/views/electronicForm/stationarySourcePermitting/StationarySourceList.vue"),
// },

export { names as recyclingReportRouteNames };

const recyclingReportRoutes: RouterOptions["routes"] = [
  {
    path: "/recyclingReports",
    name: names.recyclingReports,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Recycling Reports", lookupGroups: ["RecyclingReportStatus"] },
        component: () => import("@/views/recyclingReport/RecyclingReportList.vue"),
      },
      {
        path: "new/:organizationId(\\d+)?",
        component: () => import("@/views/recyclingReport/RecyclingReportBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Create Recycling Report", isNew: true },
            component: () => import("@/views/recyclingReport/RecyclingReportEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/recyclingReport/RecyclingReportBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Recycling Report View" },
            component: () => import("@/views/recyclingReport/RecyclingReportView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Recycling Report Edit", isForm: true },
            component: () => import("@/views/recyclingReport/RecyclingReportEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Recycling Report Internal Notes" },
            component: {
              render: () => <EntityNotes idField="reportId" routeNamePrefix="RecyclingReport.RecyclingReportNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Recycling Report Internal Note", isForm: true },
            component: () => import("@/views/recyclingReport/RecyclingReportNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Recycling Report Internal Note", isForm: true },
            component: () => import("@/views/recyclingReport/RecyclingReportNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Recycling Report Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="RecyclingReport" />,
            },
          },
        ],
      },
    ],
  },
];
export default recyclingReportRoutes;
